<template>
	<div class="error-container display-flex flex-column flex-align-center">
		<SIcon name="widget-ply-logo" class="mt-5" :width="42" />
		<div class="display-flex flex-column flex-centerize width-100 height-100 mt-n9">
			<SIcon name="non-existant-tool" :width="123" />
			<div class="title-text mt-6">Nothing to see here</div>
			<div class="description-text px-6 mt-3">The feature that lived here might have been turned off or never have existed at all.</div>
			<!-- <a class="router-container" href="https://ply.io">
				<AnemicButton class="back-to-ply-button mt-6">Back to Ply</AnemicButton>
			</a> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'NonExistantToolError',
	components: {},
	props: {},
	methods: {},
	data() {
		return {};
	},
	watch: {},
};
</script>
<style lang="scss" scoped>
.error-container {
	width: 100vw;
	height: 100vh;
}
.title-text {
	font-size: 28px;
	font-weight: 600;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 16px;
	text-align: center;
	color: var(--subtle-font-color);
}
.back-to-ply-button {
	height: 35px;
	width: 130px;
	color: var(--bg-color);
	font-size: 12px !important;
	border-radius: 3px !important;
	background: var(--forth-color) !important;
}
.router-container {
	text-decoration: none !important;
}
</style>
